import { render, staticRenderFns } from "./ZnAlphaRenzhi.vue?vue&type=template&id=345da6c5"
import script from "./ZnAlphaRenzhi.vue?vue&type=script&lang=js"
export * from "./ZnAlphaRenzhi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports